module.exports = __webpack_public_path__ + "assets/img/n_map.e4a71be7.svg";